module.exports = __webpack_public_path__ + "static/media/AgreementFeature2.073f3679.avif";